import type {
  TeamsAvgTimeSeriesRow,
  TeamsStaffSeriesRow,
} from "@/types/analytics-teams";
import type {
  TeamDetailAnalytics,
  TeamStaffDailyPoint,
  TeamStaffDetailAnalytics,
  TeamStaffDetailKpi,
} from "./staffDetailTypes";
import type { TeamStaffRow } from "./types";

function buildStaffDetailKpis(staff: TeamStaffRow): TeamStaffDetailKpi[] {
  return [
    { title: "Tasks completed", value: String(staff.tasksCompleted) },
    { title: "Tasks cancelled", value: String(staff.tasksCancelled) },
    { title: "Avg time on task", value: staff.avgTimeOnTask },
    { title: "Delays", value: String(staff.delays) },
    { title: "Day off", value: String(staff.daysOff) },
  ];
}

function buildTeamDetailKpis(team: TeamStaffRow): TeamStaffDetailKpi[] {
  return [
    { title: "Tasks completed", value: String(team.tasksCompleted) },
    { title: "Tasks cancelled", value: String(team.tasksCancelled) },
    { title: "Avg time on task", value: team.avgTimeOnTask },
  ];
}

export function mapAvgTimeSeriesToChartPoints(
  series: TeamsAvgTimeSeriesRow[] | undefined,
): TeamStaffDailyPoint[] {
  return (series ?? []).map((row) => ({
    day: row.day,
    tasksCompleted: row.taskCount,
    avgTimeOnTaskMinutes: row.avgSeconds / 60,
    tasksCancelled: 0,
    delays: 0,
  }));
}

export function mapStaffSeriesToChartPoints(
  series: TeamsStaffSeriesRow[] | undefined,
): TeamStaffDailyPoint[] {
  return (series ?? []).map((row) => ({
    day: row.day,
    tasksCompleted: row.tasksCompleted,
    avgTimeOnTaskMinutes: row.avgTimeSeconds / 60,
    tasksCancelled: row.tasksCancelled,
    delays: row.delays,
  }));
}

export function getTeamStaffDetailAnalytics(
  staff: TeamStaffRow,
): TeamStaffDetailAnalytics {
  return {
    staff,
    kpis: buildStaffDetailKpis(staff),
  };
}

export function getTeamDetailAnalytics(
  team: TeamStaffRow,
): TeamDetailAnalytics {
  return {
    team,
    kpis: buildTeamDetailKpis(team),
  };
}
